<div mat-dialog-content class="dialog-content">
  <!-- Security Pledge Section -->
  <div class="security-pledge-container">
    <h3 class="security-pledge-title">Security Pledge</h3>
    <ul class="security-pledge-list">
      <li *ngFor="let item of privacyNoticeText" class="pledge-item">
        {{ item }}
      </li>
    </ul>
  </div>

  <div class="checkbox-container">
    <mat-checkbox
      name="isSecurityPledgeCheck"
      [(ngModel)]="isSecurityPledgeCheck"
      class="checkbox"
    >
      {{ agreementStatement}}
    </mat-checkbox>
  </div>

  <div class="button-container">
    <button
      mat-raised-button
      color="primary"
      class="submit-button"
      (click)="submitTermsAndConditions()"
      [disabled]="!isSecurityPledgeCheck"
    >
      Submit
    </button>
  </div>
</div>